import React, { useEffect, useRef, useState } from 'react';
import { Button, IconButton } from '../../../../global/components/Button';
import { ObservationCreateModal, buildTagFromCheckpoint } from './ObservationCreate';
import { AutoComplete } from '../../../../global/components/Autocomplete';
import { get, first, size, flatten } from '../../../../global/lib/lodash';
import { Icon } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import ScoreTag from './ScoreTag';
import { Text } from '../../../../global/components/text';
import colors from '../../../../global/styles/colors';
import SnackAlerts from '../../../../global/components/snack-alerts';
import { Column, Row } from '../../../../global/components/row';
import clsx from 'clsx';
import { useWindowSize } from '../../../../global/hooks/useWindowSize';
import { getRealmChildTier } from 'global/utils';
import Modal from '../../../../global/components/modal';
import Form from 'global/components/form';
import sendData from 'redux/actions/sendData';
import { useUser } from '../../../../global/hooks/useUser';

export * from './ObservationCreate';

const useStyles = makeStyles((theme) => ({
  roomBtn: {
    width: 250,
    margin: '0 auto',
  },
  root: {
    backgroundColor: colors.blue,
    borderRadius: 4,
  },
  input: {
    color: colors.white,
    '&::placeholder': {
      color: colors.white,
      opacity: 1,
    },
  },
  dirButtonContainer: {
    flexDirection: 'column',
    margin: '4px 8px 0px',
    width: 100,
    alignItems: 'center',
    display: 'flex',

    '& p[type="label_medium"]': {
      textAlign: 'center',
      color: theme.colors.blue,
    },
  },
  doneRoomsRow: {
    backgroundColor: theme.palette.grey[300],
    padding: 10,
    width: `calc(100% + 25px)`,
    position: 'relative',
    left: -24,
  },
}));

export const filterRoomsByCps = (rooms, scorecard, props) => {
  const roomCps = get(scorecard, 'config.roomCheckpoints', []);
  const roomTier = get(rooms, '0.tier', 'lot');
  const allsubs = [];
  get(props, 'allScoreData', []).map((s) => {
    (s.subscores || []).map((ss) => allsubs.push(ss));
  });

  if (!size(roomCps) || roomTier !== 'room') {
    return rooms;
  }

  const ret = [];

  roomCps.map((r) => {
    const { cps, id, act } = r;
    if (act !== undefined && !act) {
      return;
    }

    if (size(cps) || !!act) {
      const room = rooms.find((r) => r.id == id);
      if (room) {
        ret.push(room);
      }
    }
  });

  allsubs.map((s) => {
    const { realmId } = s;

    if (!ret.find((r) => r.id == realmId)) {
      const room = rooms.find((r) => r.id == realmId);
      if (room) {
        ret.push(room);
      }
    }
  });

  return ret;
};

export const ObservationCreateFab = (props) => {
  const { checkpoint, activeEdit } = props;

  const classes = useStyles();

  const useRoomButtonType = true;
  const hasRoomCps = !!size(get(props, 'scorecard.config.roomCheckpoints', []));
  const tierChildLabel = getRealmChildTier(get(props, 'assessment.data.realm.tier', 'lot'));
  const hasSubScores = get(props, 'scorecard.config.hasSubScores', true);

  const scoretagRef = useRef();

  const [rooms, setRooms] = useState({
    data: [],
    loding: true,
  });

  const [alerts, setAlerts] = useState();

  const [state, setState] = useState({
    open: false,
    onClose: (created) => {
      if (created) {
        setAlerts({ message: 'INSTANCE ADDED!' });
        get(scoretagRef, 'current.searchChange', () => 0)('');
      }
      setState((s) => ({ ...s, open: false }));
    },
  });

  const updateScores = async () => {
    props.updateScores && props.updateScores(null, true);
  }

  const [scoreTag, setScoreTag] = useState({
    open: false,
    onClose: () => {
      setScoreTag((s) => ({ ...s, open: false }));
      updateScores();
    },
    useRoomSelectTitle: true,
    closeAndReset: false,
    subTitle: 'Click on inspection items below to create instances.',
    dialogProps: {
      className: '',
      fullScreen: true,
    },
  });

  const roomDrop = (p = {}) => {
    return <ButtonType rootProps={props} onChange={selectRoom} options={get(rooms, 'data', [])} {...p} {...get(props, 'roomDropProps', {})} />;
  };

  const selectRoom = (e, room) => {
    if (!room) {
      return;
    }

    if (!!checkpoint) {
      setState((s) => ({
        ...s,
        open: true,
        openTagToSelected: false,
        showRealm: false,
        canChangeTag: false,
        formState: {
          realm: room,
          tag: buildTagFromCheckpoint(checkpoint),
        },
      }));
    } else {
      setScoreTag((s) => ({
        ...s,
        open: true,
        room,
        onTagSelected: (tag) => {
          setState((s) => ({
            ...s,
            open: true,
            openTagToSelected: false,
            modalProps: {
              closeIcon: 'arrow_back',
              endIcon: '',
              renderTitle: () => {
                return (
                  <div style={{ marginLeft: 'auto' }}>
                    <Text type="headline_medium" bold>{`Add To ${room.name}`}</Text>
                  </div>
                );
              },
            },
            showRealm: false,
            canChangeTag: false,
            showAdd: false,
            checkpoint: undefined,
            formState: {
              realm: room,
              tag,
            },
          }));
        },
        renderTitleBar: () => {
          return <div style={{ marginLeft: 'auto' }}>{roomDrop({ title: `${room.name}`, placeholder: `CLICK TO CHANGE ${tierChildLabel}` })}</div>;
        },
      }));
    }
    let elem = document.getElementById('tagSubtitle');
    if (elem) {
      elem.scrollIntoView(true);
    }
  };

  const hasActiveRealm = ['room', 'lot', 'community'].indexOf(get(props, 'checklist.type')) !== -1 ? get(props, 'checklist') : false;

  const clickAdd = () => {
    if (hasActiveRealm) {
      selectRoom(null, hasActiveRealm);
    } else {
      setState((s) => ({ ...s, open: true }));
    }
  };

  const onReview = () => {
    scoreTag.onClose();
    props.onReview && props.onReview();
  };

  const renderButtonType = () => {
    const isLocationFilter = get(props, 'filter.listGroup', '') === 'location';

    if (useRoomButtonType && !hasActiveRealm) {
      return (
        <div className={clsx(classes.roomBtn, 'roomBtn')}>
          {roomDrop({
            variant: activeEdit ? 'outlined' : 'standard',
            size: 'small',
            placeholder: isLocationFilter ? 'ADD INSTANCE' : `ADD BY ${getRealmChildTier(get(props, 'assessment.data.realm.tier', 'lot'))}`,
            classes: { root: classes.root, input: classes.input },
          })}
        </div>
      );
    }
    return (
      <Button style={{ marginLeft: 8, ...(props.style || {}) }} color="secondary" onClick={clickAdd} icon={'add'}>
        ADD INSTANCE
      </Button>
    );
  };

  const getRoomDir = () => {
    const ind = (rooms.data || []).findIndex((r) => r.id == get(scoreTag, 'room.id'));

    return {
      prev: rooms.data[ind - 1],
      next: rooms.data[ind + 1],
      cur: rooms.data[ind],
    };
  };

  const renderFooter = () => {
    if (hasRoomCps) {
      const roomDir = getRoomDir();
      return (
        <div>
          <Row center style={{ padding: 10, alignItems: 'flex-start', margin: '36px 4px 48px' }}>
            <div className={classes.dirButtonContainer}>
              <IconButton size={'small'} color="secondary" disabled={!roomDir.prev} icon="chevron_left" onClick={() => selectRoom(null, roomDir.prev)} title="PREV" />
              <div>
                <Text type="label_medium">{get(roomDir, 'prev.name', '')}</Text>
              </div>
            </div>
            <div style={{ minWidth: 250 }}>{roomDrop({ variant: 'standard', placeholder: `CHANGE ${tierChildLabel}`, classes: { root: classes.root, input: classes.input } })}</div>
            <div className={classes.dirButtonContainer}>
              <IconButton size={'small'} color="secondary" disabled={!roomDir.next} icon="chevron_right" onClick={() => selectRoom(null, roomDir.next)} title="NEXT" />
              <div>
                <Text type="label_medium">{get(roomDir, 'next.name', '')}</Text>
              </div>
            </div>
          </Row>
          <Row center className={classes.doneRoomsRow}>
            <Column center>
              <Text type="label_large">Done with all rooms?</Text>
              <Button title="REVIEW SCORES" onClick={onReview} style={{ marginBottom: 16 }} />
            </Column>
          </Row>
        </div>
      );
    } else {
      return (
        <Row center>
          <div style={{ width: 200, padding: 10 }}>
            {roomDrop({ variant: 'outlined', size: 'small', placeholder: `CHANGE ${tierChildLabel}`, classes: { root: classes.root, input: classes.input } })}
          </div>
        </Row>
      );
    }
  };

  useEffect(() => {
    if (!scoreTag.open) {
      setRooms({
        ...props.rooms,
        data: filterRoomsByCps(get(props, 'rooms.data'), props.scorecard, props),
      });
    }
  }, [get(props, 'rooms.data'), props.allScoreData]);

  return !hasSubScores ? null : (
    <>
      {renderButtonType()}
      <ScoreTag {...props} ref={scoretagRef} rooms={rooms} {...scoreTag} renderFooter={renderFooter} />
      <ObservationCreateModal {...props} rooms={rooms} {...state} />
      <SnackAlerts alerts={alerts} setAlerts={setAlerts} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} />
    </>
  );
};

const btnClasses = makeStyles((theme) => ({
  container: {
    cursor: 'pointer',
    width: (p) => p.defaultWidth,
    flexDirection: 'column',
    alignItems: 'flex-end',
    display: 'flex',
    '& input': {
      padding: `${theme.spacing(1)} !important`,
    },
  },
  button: {
    width: (p) => p.defaultWidth,
    paddingRight: '2px',
    marginRight: '-2px',
  },
  noScroll: {
    overflow: 'hidden',
    height: '100%',
  },
}));

const ButtonType = (props) => {
  const [state, setState] = useState({
    open: false,
  });

  const [createroom, setcreateroom] = useState({
    open: false,
    onClose: () => {
      setcreateroom((s) => ({ ...s, open: false }));
    },
  });

  const defaultWidth = 250;

  const { isMobileXS, windowSize } = useWindowSize();
  const autoCompleteRef = useRef();

  const hasTitle = get(props, 'title');

  const tierChildLabel = getRealmChildTier(get(props, 'rootProps.assessment.data.realm.tier', 'lot'));
  const placeholder = get(props, 'placeholder', `ADD BY ${tierChildLabel}`).toUpperCase();

  const styles = btnClasses({ ...state, hasTitle, defaultWidth });

  useEffect(() => {
    const body = document.body;
    if (state.open) {
      body.classList.add(styles.noScroll);
    } else {
      body.classList.remove(styles.noScroll);
    }

    return () => {
      body.classList.remove(styles.noScroll);
    };
  }, [state]);

  const onOpen = () => {
    setState((s) => ({ ...s, open: true }));
  };

  const onClose = () => {
    setState((s) => ({ ...s, open: false }));
  };

  const onChange = (e, room) => {
    setState((s) => ({ ...s, open: false }));

    if (room && room.id === 'addnew') {
      setcreateroom((s) => ({
        ...s,
        title: `Create new ${tierChildLabel}`.toUpperCase(),
        open: true,
        onSubmit: (rm) => {
          props.onChange && props.onChange(e, rm);
          s.onClose();
        },
      }));
    } else {
      props.onChange && props.onChange(e, room);
    }
  };

  const clickContainer = () => {
    setState((s) => ({ ...s, open: true }));
  };

  const getButton = () => {
    if (hasTitle) {
      return (
        <Row style={{ justifyContent: 'flex-end' }}>
          <Text variant={'overline'} style={{ marginRight: 8, lineHeight: 'inherit' }}>
            {placeholder}
          </Text>
          <Icon>arrow_drop_down</Icon>
        </Row>
      );
    }
    return (
      <Button className={styles.button} onClick={clickContainer} variant={get(props, 'variant', 'standard')}>
        <Row fullWidth spaceBetween>
          {placeholder}
          <Icon>arrow_drop_down</Icon>
        </Row>
      </Button>
    );
  };

  return (
    <>
      <div onClick={!state.open ? clickContainer : undefined} className={styles.container}>
        {!!hasTitle && (
          <div style={{ width: windowSize.innerWidth - 90, textAlign: 'right' }}>
            <Text style={{ fontSize: state.open ? (isMobileXS ? 11 : 14) : isMobileXS ? 20 : 28, overflow: 'hidden', overflowX: 'auto', whiteSpace: 'nowrap' }} bold>
              <u>{hasTitle}</u>
            </Text>
          </div>
        )}

        {!state.open && getButton()}

        {state.open && (
          <AutoComplete
            autoFocus={!isMobileXS}
            variant="standard"
            getOptionLabel={(d) => {
              const name = get(d, 'name', '');
              return name;
            }}
            multiple={false}
            {...props}
            options={props.options}
            ref={autoCompleteRef}
            placeholder={placeholder}
            onOpen={onOpen}
            onClose={onClose}
            onChange={onChange}
            open={state.open}
            alwaysInclude={[{ name: `+ Add new ${tierChildLabel}`, id: 'addnew' }]}
          />
        )}
      </div>
      <NewRoomCreate {...createroom} rootProps={props.rootProps} />
    </>
  );
};

const NewRoomCreate = (props) => {
  const { me } = useUser();
  const onSubmit = async (vals) => {
    try {
      const rooms = get(props, 'rootProps.rooms', {});
      const foundRoom = get(rooms, 'data', []).find((r) => {
        return r.name.toLowerCase() == vals.name.toLowerCase();
      });

      if (foundRoom) {
        props.onSubmit(foundRoom);
      } else {
        const arealm = get(props, 'rootProps.assessment.data.realm');

        const tier = getRealmChildTier(get(arealm, 'tier', 'lot')).toLowerCase();

        const result = await sendData(
          {
            url: `/realms`,
            method: 'post',
            data: {
              data: {
                type: 'realms',
                attributes: {
                  user_id: me.id,
                  name: vals.name,
                  tier: tier,
                  parent_id: get(first(rooms.data), 'parentId') || get(arealm, 'id'),
                },
              },
            },
          },
          { normalize: { build: ['realms'] } }
        );

        await get(props, 'rootProps.rooms.update', () => 0)();

        props.onSubmit(result[0]);
      }
    } catch (err) {
      alert(err);
    }
  };

  return (
    <Modal {...props}>
      <Form
        showAllScreens
        onSubmit={onSubmit}
        submitText="Submit"
        canSubmit={true}
        submitBtnBoxStyle={{ position: 'relative' }}
        useCheckContinue
        screens={[
          {
            title: '',
            inputs: [
              {
                id: 'name',
                type: 'TextField',
                props: {
                  label: 'Name',
                  required: true,
                },
              },
            ],
          },
        ]}
      />
    </Modal>
  );
};
